import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-expanded", "aria-label"]
const _hoisted_2 = { class: "product-variation-input__head-row" }
const _hoisted_3 = { class: "product-variation-input__value-row" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "product-variation-input__options-wrapper"
}
const _hoisted_6 = {
  id: "product-variation-input-options",
  class: "product-variation-input__options",
  "aria-live": "polite",
  role: "listbox"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-variation-input", {
      'product-variation-input--open': _ctx.isOpen && !_ctx.isDisabled,
    }]),
    "aria-expanded": _ctx.isOpen && !_ctx.isDisabled,
    "aria-label": _ctx.attributeNames.map(attr => _ctx.$t(`product.variation.attribute.${attr}`)).join(', '),
    role: "combobox"
  }, [
    _createElementVNode("div", {
      class: "product-variation-input__select",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onToggleSelect && _ctx.onToggleSelect(...args))),
      onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleKeyDown && _ctx.handleKeyDown(...args))),
      role: "button",
      tabindex: "0",
      "aria-controls": "product-variation-input-options"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributeNames, (attributeName) => {
          return (_openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["product-variation-input__cell", `product-variation-input__cell--${attributeName}`]),
            key: attributeName
          }, _toDisplayString(_ctx.$t(`product.variation.attribute.${attributeName}`)), 3 /* TEXT, CLASS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedItem.attributes, (attribute) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "product-variation-input__cell",
            key: attribute.value,
            innerHTML: _ctx.getAttributeValue(attribute)
          }, null, 8 /* PROPS */, _hoisted_4))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ], 32 /* NEED_HYDRATION */),
    _cache[3] || (_cache[3] = _createTextVNode()),
    (_ctx.isOpen && !_ctx.isDisabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variations.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["product-variation-input__value-row", {
            'product-variation-input__value-row--selected': _ctx.selectedItem.itemId === item.itemId,
            'product-variation-input__value-row--unavailable': !item.availability.available,
            'product-variation-input__value-row--highlighted': _ctx.highlightedItemIndex === index,
          }]),
                key: item.itemId,
                onClick: ($event: any) => (_ctx.onSelectItem(item)),
                role: "listitem"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.attributes, (attribute) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "product-variation-input__cell",
                    key: attribute.value,
                    innerHTML: _ctx.getAttributeValue(attribute)
                  }, null, 8 /* PROPS */, _hoisted_8))
                }), 128 /* KEYED_FRAGMENT */))
              ], 10 /* CLASS, PROPS */, _hoisted_7))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}